import React, { useState } from 'react'
import ViewFileIndex from '../../../components/View/ViewFileIndex'
import { useStandard } from '../../../context/StandardContext';
import UseGetInsideData from '../../../hooks/useFetchInsideData';
import { useParams } from 'react-router-dom';
import CommonCardView from '../../../utils/CommonCardView';
import CommonTableView from '../../../utils/CommonTableView';
import CommonImgForm from '../../../utils/CommonImgForm';

function StatutoryReporting() {
  const { standardName } = useStandard();
  const {stdId} = useParams()
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [pageIndex, setPageIndex] = useState(1);
  const [dataCount, setDataCount] = useState(20);
  const [view,setView] = useState(localStorage.getItem('view')||2)
  const [searchQuery, setSearchQuery] = useState("");
  const {data, totalCount,getData,isLoading} = UseGetInsideData({url:`/Statutory_Reporting/standard/${stdId}/`,page:pageIndex,pageCount:dataCount,search:searchQuery})

  function SearchData(e) {
    e.preventDefault();
    if (searchQuery != "") {
    
      getData();
    } else {
      getData();
    }
  }

  function handleValueChange(e){
    if(e.target.value !=""){
      setSearchQuery(e.target.value)
    }else{
      getData()
    }
  }

  function listView(){
    localStorage.setItem('view',2);
    setView(2)
  }
  function cardView(){
    localStorage.setItem('view',1);
    setView(1)
  }

  let link = "Statutory_Reporting"

  return (
    <ViewFileIndex 
     label='Statutory Reporting'
     menu="Reference Docs"
     information='This page should be used to upload reports generated and submitted to Statutory and Govt agencies'
     standardName={standardName}
     total={totalCount} 
     setDataCount={setDataCount} 
     dataCount={dataCount} 
     pageIndex={pageIndex} 
     setPageIndex={setPageIndex} 
     view={view} 
     listView={listView} 
     cardView={cardView} 
     setOpenForm={setShowMyModal}
     Access="glossary_create"
     hasSearch={true}
     SearchQuery={handleValueChange}
     SearchFuction={SearchData}
     >
     {
      view == true? <CommonCardView isLoading={isLoading} data={data} link={link} accessString="glossary_delete" fetcher={getData}/> : <CommonTableView accessString="glossary_delete" isLoading={isLoading} data={data} fetcher={getData} link={link} />
     }
     <CommonImgForm
       visible={showMyModal}
       onClose={handleOnClose}
       refreshData={getData}
       url={`/Statutory_Reporting/standard/${stdId}/`}
       appendText='statutory_reporting'
      />
    </ViewFileIndex>
  )
}

export default StatutoryReporting;